/**
 * BayWhiz Analytics Gate
 *
 * CONTROLLED FREE-TRIAL LAUNCH POSTURE:
 * - Both Google Analytics (GA4) and PostHog are explicitly disabled (`ANALYTICS_ENABLED = false`).
 * - Neither `VITE_GA_MEASUREMENT_ID`, `VITE_ANALYTICS_PROVIDER`, nor `VITE_POSTHOG_KEY`
 *   can silently activate third-party tracking while `ANALYTICS_ENABLED` is `false`.
 * - No replacement tracker is initialized.
 *
 * AUDITABLE RESTORATION PROCEDURE (Post-Legal Approval):
 * 1. Publish final counsel-approved Privacy Policy (`/privacy`) and any required cookie/consent banner.
 * 2. Set `ANALYTICS_ENABLED = true` below and wire initialization strictly behind user consent (if required).
 */

export const ANALYTICS_ENABLED = false;

export const initAnalytics = (): void => {
    if (!ANALYTICS_ENABLED) {
        // Explicitly neutralize any residual global gtag or dataLayer hooks
        if (typeof window !== 'undefined') {
            delete (window as any).gtag;
        }
        return;
    }
};

export const track = (_event: string, _props: Record<string, unknown> = {}): void => {
    if (!ANALYTICS_ENABLED) return;
};

export const trackMarketingEvent = (
    _eventName: string,
    _params: Record<string, unknown> = {}
): void => {
    if (!ANALYTICS_ENABLED) return;
};
